import { FC } from 'react'
import { NavIcon } from './NavIcon'

export interface INavSubItemMarkerProps {
  icon?: FC
  /** Подпункт на светлой подложке — в поповере свёрнутого меню */
  light?: boolean
}

/**
 * В древе меню у подпункта вместо иконки точка. Её бокс шириной с иконку раздела, а отступ
 * слева у строк общий: точки стоят на оси иконок разделов, подписи — на оси их подписей.
 * Точка красится цветом текста строки, поэтому всегда совпадает с подписью.
 * В поповере свёрнутого меню остаются иконки
 */
export const NavSubItemMarker = ({ icon, light = false }: INavSubItemMarkerProps) => {
  if (light) return icon ? <NavIcon icon={icon} /> : null

  return (
    <div className={'flex w-[20px] min-w-[20px] justify-center'}>
      <span className={'h-[4px] w-[4px] rounded-full bg-[currentColor]'} />
    </div>
  )
}
